import { ObjectExtensions } from '@mosaik/core';
import { IIconFont } from './Interfaces/IIconFont';

/**
 * @public
 * @dynamic
 */
export class IconFonts {
  public static get material(): IIconFont {
    return { alias: 'material', className: 'material-icons', isLigature: true, isNameWithClassName: false };
  }

  public static get fontawesome(): IIconFont {
    return { alias: 'fontawesome', className: 'fa', isLigature: false, isNameWithClassName: true };
  }

  public static get brightSummer(): IIconFont {
    return { alias: 'brightSummer', className: 'bs-icon', isLigature: false, isNameWithClassName: true };
  }

  public static get codeBlue(): IIconFont {
    return { alias: 'codeBlue', className: 'cb-icon', isLigature: false, isNameWithClassName: true };
  }

  public static forProvider(): Array<IIconFont> {
    return ObjectExtensions.toArray<IIconFont>(IconFonts);
  }
}
